export const ID = '80b7ecbe-b01b-11ea-b3de-0242ac130004';

export const NAME = 'Breadcrumbs';
